import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { usePortalClient } from './usePortalClient';
import EmptyState from '../shared/components/EmptyState';
import Skeleton from '../shared/components/Skeleton';
import StatusPill from '../shared/components/StatusPill';
import { date } from '../shared/formatters';
import PortalHeader from './PortalHeader';

export default function History() {
  const { data } = useData();
  const { client, base } = usePortalClient();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 220);
    return () => clearTimeout(timer);
  }, []);

  const jobs = useMemo(
    () => data.jobs
      .filter((item) => item.client_id === client.id)
      .sort((a, b) => new Date(b.date) - new Date(a.date)),
    [client.id, data.jobs]
  );

  if (loading) {
    return <Skeleton rows={4} />;
  }

  return (
    <>
      <PortalHeader
        eyebrow="Property record"
        title="Work history"
        description="A complete record of work carried out at your property."
      />

      {!jobs.length ? (
        <EmptyState title="No work history yet" message="Completed and upcoming jobs will appear here." />
      ) : (
        <section className="portal-card job-list">
          {jobs.map((job) => (
            <Link to={`${base}/history/${job.id}`} key={job.id}>
              <div>
                <span>{date(job.date)} · {job.engineer}</span>
                <h3>{job.title}</h3>
                <p>{job.description}</p>
              </div>
              <StatusPill status={job.status} />
            </Link>
          ))}
        </section>
      )}
    </>
  );
}